import HiddenTypography from 'components/hidden-typography/hidden-typography.component';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import AddressAutoCompleteInput from '../address-autocomplete/address-autocomplete-input/address-autocomplete-input.component';
import * as S from '../address-autocomplete/address-autocomplete.styles';
import { getOptionLabel } from '../address-autocomplete/address-autocomplete.utils';
import { useMapboxGeocoding } from './search-box-autocomplete.hooks';
import SearchBoxOption from './search-box-option.component';

const SearchBoxAutocomplete = ({
  name,
  onChange,
  autocompleteProps,
  autocompleteInputProps,
  formErrorProps,
  value,
  ...rest
}) => {
  const { t } = useTranslation();
  const { setSearchText, suggestions, fetchPermanentAddress } =
    useMapboxGeocoding();

  const handleInputChange = useCallback(
    async (e, newValue) => {
      if (!e || e.type === 'click' || e.type === 'blur' || !newValue) return;
      setSearchText(newValue);
    },
    [setSearchText],
  );

  return (
    <>
      <HiddenTypography id="address-control-instructions">
        {t('addressSelect.aria.instructions')}
      </HiddenTypography>
      <HiddenTypography aria-live="polite">
        {t('addressSelect.aria.noOfOptions', { count: suggestions.length })}
      </HiddenTypography>
      <S.CustomAutocomplete
        id={name}
        fullWidth
        filterOptions={x => x}
        getOptionLabel={getOptionLabel}
        options={suggestions}
        includeInputInList
        isOptionEqualToValue={(option, value) =>
          option.place_id === value.placeId
        }
        onChange={async (_e, newValue) => {
          if (!newValue) return onChange(null);
          const address = await fetchPermanentAddress(newValue.full_address);
          const value = {
            ...address,
            description: newValue.description,
            main_text: newValue.address,
          };
          onChange(value);
        }}
        onInputChange={handleInputChange}
        renderInput={({ inputProps, ...paramsRest }) => (
          <AddressAutoCompleteInput
            name={name}
            fullWidth
            {...paramsRest}
            inputProps={{
              'aria-labelledby': 'address-control-label',
              'aria-describedby': 'address-control-instructions',
              ...inputProps,
              ...autocompleteInputProps,
            }}
            formErrorProps={formErrorProps}
          />
        )}
        renderOption={(props, option) => (
          <li {...props}>
            <SearchBoxOption option={option} />
          </li>
        )}
        {...autocompleteProps}
        {...rest}
      />
    </>
  );
};
export default SearchBoxAutocomplete;
